import { IBusinessGrossRevenueCapsule, IBusinessGrossRevenueOverview } from "../BusinessManagement/type.d";
import { ICapsuleData } from "@/pages/strategic/components/CapsuleBar/type.d";
import { IBusinessMetricCardConfig } from '@/pages/strategic/pages/BusinessManagement/type.d';
import { buildUpdateTime, buildPeriod, buildFullYearPeriod, getYearPrefix, roundToDisplayPrecision } from '@sg/utils/common';
import TimeLineIcon from '@sg/components/TimeLine/TimeLineIcon';
import moment from 'moment';

export const PUBLISHING_OVERVIEW_TOTAL_REVENUE_CAPSULE = (apiData?: any): ICapsuleData[] => {
  const revenueData = apiData?.revenue || {};
  const value25A = roundToDisplayPrecision(revenueData['25A']);
  const value25F = roundToDisplayPrecision(revenueData['25F']);
  const value25B = roundToDisplayPrecision(revenueData['25B']);
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);

  // Calculate rates based on 25B as 100%
  const rate25A = value25B !== 0 && value25B != null && value25A !== null && value25A !== undefined
    ? Math.round((value25A / value25B) * 100)
    : undefined;
  const rate25F = value25B !== 0 && value25B != null && value25F !== null && value25F !== undefined
    ? Math.round((value25F / value25B) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: value25A,
      rate: rate25A,
      type: 'pillar',
      colorType: 'skyBlue',
      insideAlign: 'dynamic',
      isBold: true,
      precision: 1,
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: value25F,
      rate: rate25F,
      type: 'pillar',
      colorType: 'purple',
      insideAlign: 'dynamic',
      isBold: true,
      precision: 1,
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: value25B,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

export const PUBLISHING_OVERVIEW_TOTAL_PROFIT_CAPSULE = (apiData?: any): ICapsuleData[] => {
  const profitData = apiData?.profit || {};
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(profitData['25A']),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      colorType: 'skyBlue',
      insideAlign: 'dynamic',
      isBold: true,
      precision: 1,
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: roundToDisplayPrecision(profitData['25F']),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      colorType: 'purple',
      insideAlign: 'dynamic',
      isBold: true,
      precision: 1,
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(profitData['25B']),
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

export const PUBLISHING_MKTCOST_TOTAL_MKTCOST_CAPSULE = (apiData?: any): ICapsuleData[] => {
  const mktCostData = apiData?.mkt_cost || {};
  const value25A = roundToDisplayPrecision(mktCostData['25A']);
  const value25F = roundToDisplayPrecision(mktCostData['25F']);
  const value25B = roundToDisplayPrecision(mktCostData['25B']);
  const yearPrefix = getYearPrefix(apiData?.mkt_cost?.datatime);

  // Calculate rates based on 25B as 100%
  const rate25A = value25B !== 0 && value25B != null && value25A !== null && value25A !== undefined
    ? Math.round((value25A / value25B) * 100)
    : undefined;
  const rate25F = value25B !== 0 && value25B != null && value25F !== null && value25F !== undefined
    ? Math.round((value25F / value25B) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: value25A,
      rate: rate25A,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: value25F,
      rate: rate25F,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: value25B,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

export const PUBLISHING_MKTCOST_TOTAL_REVENUE_CAPSULE = (apiData?: any): ICapsuleData[] => {
  const revenueData = apiData?.gross_revenue || {};
  const value25A = roundToDisplayPrecision(revenueData['25A']);
  const value25F = roundToDisplayPrecision(revenueData['25F']);
  const value25B = roundToDisplayPrecision(revenueData['25B']);
  const yearPrefix = getYearPrefix(apiData?.gross_revenue?.datatime);

  // Calculate rates based on 25B as 100%
  const rate25A = value25B !== 0 && value25B != null && value25A !== null && value25A !== undefined
    ? Math.round((value25A / value25B) * 100)
    : undefined;
  const rate25F = value25B !== 0 && value25B != null && value25F !== null && value25F !== undefined
    ? Math.round((value25F / value25B) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: value25A,
      rate: rate25A,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: value25F,
      rate: rate25F,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: value25B,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

const PUBLISHING_PROJECT_REVENUE_CAPSULE = (apiData?: any): ICapsuleData[] => {
  const actual = roundToDisplayPrecision(apiData?.actual);
  const forecast = roundToDisplayPrecision(apiData?.forecast);
  const kpi = roundToDisplayPrecision(apiData?.kpi);
  const yearPrefix = getYearPrefix(apiData?.datatime);

  // Calculate rates based on KPI as 100%
  const rate25A = kpi !== 0 && kpi != null && actual !== null && actual !== undefined
    ? Math.round((actual / kpi) * 100)
    : undefined;
  const rate25F = kpi !== 0 && kpi != null && forecast !== null && forecast !== undefined
    ? Math.round((forecast / kpi) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: actual,
      rate: rate25A,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: forecast,
      rate: rate25F,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};
const PUBLISHING_PROJECT_MKT_COST_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actual = roundToDisplayPrecision(apiData?.actual);
  const forecast = roundToDisplayPrecision(apiData?.forecast);
  const kpi = roundToDisplayPrecision(apiData?.kpi);
  const yearPrefix = getYearPrefix(apiData?.datatime);

  // Calculate rates based on KPI as 100%
  const rate25A = kpi !== 0 && kpi != null && actual !== null && actual !== undefined
    ? Math.round((actual / kpi) * 100)
    : undefined;
  const rate25F = kpi !== 0 && kpi != null && forecast !== null && forecast !== undefined
    ? Math.round((forecast / kpi) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: actual,
      rate: rate25A,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: forecast,
      rate: rate25F,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};
const PUBLISHING_PROJECT_HEADCOUNT_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actual = apiData?.actual;
  const ytmActualAvg = apiData?.ytm_actual_avg;
  const fullYearKpiAvg = apiData?.full_year_kpi_avg;

  const actualRate = fullYearKpiAvg !== 0 && fullYearKpiAvg != null && actual !== null && actual !== undefined
    ? Math.round((actual / fullYearKpiAvg) * 100)
    : undefined;
  const ytmRate = fullYearKpiAvg !== 0 && fullYearKpiAvg != null && ytmActualAvg !== null && ytmActualAvg !== undefined
    ? Math.round((ytmActualAvg / fullYearKpiAvg) * 100)
    : undefined;

  return [
    {
      title: 'Actual',
      showRate: false,
      localeTitleKey: 'dbs_actual',
      value: actual,
      rate: actualRate,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      unit: '',
      insideAlign: 'dynamic',
    },
    {
      title: 'YTM Actual Avg.',
      showRate: false,
      localeTitleKey: 'dbs_ytm_actual_avg',
      value: ytmActualAvg,
      rate: ytmRate,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      unit: '',
      insideAlign: 'dynamic',
    },
    {
      title: 'Full Year KPI Avg.',
      localeTitleKey: 'dbs_full_year_kpi_avg',
      value: fullYearKpiAvg,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
      unit: '',
      preventMarkOverflow: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};
const PUBLISHING_PROJECT_TECH_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actual = roundToDisplayPrecision(apiData?.actual);
  const yearPrefix = getYearPrefix(apiData?.datatime);
  // 接口 /api/v1/mgmt_pc/publishing/publishing_project/tech_cost 不再返回 forecast 和 kpi 参数，移除 25F 和 25B 指标
  // const forecast = apiData?.forecast;
  // const kpi = apiData?.kpi;

  // Calculate rates based on KPI as 100%
  // const rate25A = kpi !== 0 && kpi != null && actual !== null && actual !== undefined
  //   ? Math.round((actual / kpi) * 100)
  //   : undefined;
  // const rate25F = kpi !== 0 && kpi != null && forecast !== null && forecast !== undefined
  //   ? Math.round((forecast / kpi) * 100)
  //   : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: actual,
      // rate: rate25A,
      showRate: false, // 隐藏百分比显示
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      insideAlign: 'dynamic',
    },
    // {
    //   title: '25F',
    //   localeTitleKey: 'dbs_full_year_forecast_short',
    //   value: forecast,
    //   rate: rate25F,
    //   type: 'pillar',
    //   colorType: 'purple',
    //   isBold: true,
    //   precision: 1,
    //   insideAlign: 'dynamic',
    // },
    // {
    //   title: '25B',
    //   localeTitleKey: 'dbs_full_year_kpi_short',
    //   value: kpi,
    //   rate: 100,
    //   type: 'total',
    //   markWidth: 2,
    //   titlePosition: 'top',
    //   colorType: 'orange',
    //   titleField: 'title',
    //   markHeight: 40,
    //   displayTitleFormat: 'title',
    //   isBold: true,
    // },
    // 添加一个隐藏的 total 项，避免 SingleBar 创建默认的 totalPoint 并显示 mark
    {
      title: '',
      value: 0,
      rate: 0,
      type: 'total',
      markWidth: 2,
      markHeight: 40,
      isHide: true,
      colorType: 'orange',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};
const PUBLISHING_HEADCOUNT_HEADCOUNT_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actual = apiData?.actual;
  const ytmActualAvg = apiData?.ytm_actual_avg;
  const fullYearKPIAvg = apiData?.full_year_kpi_avg;

  // Calculate rates based on fullYearKPIAvg as 100%
  const rateActual = fullYearKPIAvg !== 0 && fullYearKPIAvg != null && actual !== null && actual !== undefined
    ? Math.round((actual / fullYearKPIAvg) * 100)
    : undefined;
  const rateYTMAvg = fullYearKPIAvg !== 0 && fullYearKPIAvg != null && ytmActualAvg !== null && ytmActualAvg !== undefined
    ? Math.round((ytmActualAvg / fullYearKPIAvg) * 100)
    : undefined;

  return [
    {
      title: 'Actual',
      localeTitleKey: 'dbs_actual',
      value: actual,
      rate: rateActual,
      type: 'pillar',
      colorType: 'skyBlue',
      isBold: true,
      precision: 1,
      unit: '',
      insideAlign: 'dynamic',
    },
    {
      title: 'YTM Actual Avg.',
      localeTitleKey: 'dbs_ytm_actual_avg',
      value: ytmActualAvg,
      rate: rateYTMAvg,
      type: 'pillar',
      colorType: 'purple',
      isBold: true,
      precision: 1,
      unit: '' ,
      insideAlign: 'dynamic',
    },
    {
      title: 'Full Year KPI Avg.',
      localeTitleKey: 'dbs_full_year_kpi_avg',
      value: fullYearKPIAvg,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
      unit: '',
      preventMarkOverflow: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

export const PUBLISHING_OVERVIEW_TOTAL_REVENUE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_OVERVIEW_TOTAL_REVENUE_CAPSULE(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_OVERVIEW_TOTAL_PROFIT = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_OVERVIEW_TOTAL_PROFIT_CAPSULE(apiData),
  directionType: 'normal'
}];

export const PUBLISHING_MKTCOST_TOTAL_MKTCOST = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_MKTCOST_TOTAL_MKTCOST_CAPSULE(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_MKTCOST_TOTAL_REVENUE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_MKTCOST_TOTAL_REVENUE_CAPSULE(apiData),
  directionType: 'normal'
}];

export const PUBLISHING_PROJECT_REVENUE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_PROJECT_REVENUE_CAPSULE(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_PROJECT_MKT_COST = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_PROJECT_MKT_COST_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_PROJECT_HEADCOUNT = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_PROJECT_HEADCOUNT_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_PROJECT_TECH = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_PROJECT_TECH_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_HEADCOUNT_HEADCOUNT = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: PUBLISHING_HEADCOUNT_HEADCOUNT_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const PUBLISHING_OVERVIEW_TOTAL_REVEUNE_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const revenueData = apiData?.revenue || {};
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);

  return [
    {
      title: `YTM Actual (${yearPrefix}A)`,
      key: '25A',
      value: revenueData['25A'],
      precision: 1,
      // 接口 /api/v1/mgmt_pc/publishing/executive-summary 不再返回 25A_yoy 参数，改为只使用 MoM
      // ratioUnit: 'YoY,MoM',
      // ratioValue: [revenueData['25A_yoy'] || 0, revenueData['25A_mom'] || 0].join(','),
      ratioUnit: 'MoM',
      ratioValue: (revenueData['25A_mom'] || 0).toString(),
      definition: 'dbs_ytm_acutal_definition',
      updateTime: 'dbs_update_time_month',
      source: 'dbs_update_source_finance',
      colorType: 'skyBlue',
      period: buildPeriod(apiData?.revenue?.date),
    },
    {
      title: `Full Year Forecast (${yearPrefix}F)`,
      key: '25F',
      value: revenueData['25F'],
      precision: 1,
      ratioUnit: 'YoY',
      ratioValue: (revenueData['25F_yoy'] || 0).toString(),
      definition: 'dbs_full_year_forecast_definition',
      updateTime: 'dbs_update_time_need',
      source: 'dbs_update_source_finance',
      colorType: 'purple',
      period: buildFullYearPeriod(apiData?.revenue?.date),
    },
    {
      title: `Full Year KPI (${yearPrefix}B)`,
      key: '25B',
      value: revenueData['25B'],
      precision: 1,
      ratioUnit: 'YoY',
      ratioValue: (revenueData['25B_yoy'] || 0).toString(),
      definition: 'dbs_full_year_kpi_definition_l2',
      updateTime: 'dbs_update_time_year',
      source: 'dbs_update_source_finance',
      colorType: 'orange',
      period: buildFullYearPeriod(apiData?.revenue?.date),
    }
  ];
};

export const PUBLISHING_OVERVIEW_TOTAL_PROFIT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const profitData = apiData?.profit || {};
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);

  return [
    {
      title: `YTM Actual (${yearPrefix}A)`,
      key: '25A',
      value: profitData['25A'],
      precision: 1,
      // 接口 /api/v1/mgmt_pc/publishing/executive-summary 不再返回 25A_yoy 参数，改为只使用 MoM
      // ratioUnit: 'YoY,MoM',
      // ratioValue: [profitData['25A_yoy'] || 0, profitData['25A_mom'] || 0].join(','),
      ratioUnit: 'MoM',
      ratioValue: (profitData['25A_mom'] || 0).toString(),
      definition: 'dbs_ytm_acutal_definition',
      updateTime: 'dbs_update_time_month',
      source: 'dbs_update_source_finance',
      colorType: 'skyBlue',
      period: buildPeriod(apiData?.profit?.date),
    },
    {
      title: `Full Year Forecast (${yearPrefix}F)`,
      key: '25F',
      value: profitData['25F'],
      precision: 1,
      ratioUnit: 'YoY',
      ratioValue: (profitData['25F_yoy'] || 0).toString(),
      definition: 'dbs_full_year_forecast_definition',
      updateTime: 'dbs_update_time_need',
      source: 'dbs_update_source_finance',
      colorType: 'purple',
      period: buildFullYearPeriod(apiData?.profit?.date),
    },
    {
      title: `Full Year KPI (${yearPrefix}B)`,
      key: '25B',
      value: profitData['25B'],
      precision: 1,
      ratioUnit: 'YoY',
      ratioValue: (profitData['25B_yoy'] || 0).toString(),
      definition: 'dbs_full_year_kpi_definition_l2',
      updateTime: 'dbs_update_time_year',
      source: 'dbs_update_source_finance',
      colorType: 'orange',
      period: buildFullYearPeriod(apiData?.profit?.date),
    }
  ];
};

export const PUBLISHING_MKTCOST_TOTAL_MKTCOST_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const mktCostData = apiData?.mkt_cost || {};
  const yearPrefix = getYearPrefix(apiData?.mkt_cost?.datatime);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: mktCostData['25A'],
    precision: 1,
    // 接口 /api/v1/mgmt_pc/publishing/mkt_cost/executive-summary 不再返回 25A_yoy 参数，移除 ratioUnit 和 ratioValue
    // ratioUnit: 'YoY',
    // ratioValue: mktCostData['25A_yoy']?.toString(),
    definition: 'dbs_mkt_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_gms',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.mkt_cost?.date),
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: mktCostData['25F'],
    precision: 1,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.mkt_cost?.date),
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: mktCostData['25B'],
    precision: 1,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.mkt_cost?.date),
  }];
};

export const PUBLISHING_MKTCOST_TOTAL_REVENUE_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const revenueData = apiData?.gross_revenue || {};
  const yearPrefix = getYearPrefix(apiData?.gross_revenue?.datatime);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: revenueData['25A'],
    precision: 1,
    // 接口 /api/v1/mgmt_pc/publishing/mkt_cost/executive-summary 不再返回 25A_yoy 参数，改为只使用 MoM
    // ratioUnit: 'YoY,MoM',
    // ratioValue: `${revenueData['25A_yoy'] || 0},${revenueData['25A_mom'] || 0}`,
    ratioUnit: 'MoM',
    ratioValue: (revenueData['25A_mom'] || 0).toString(),
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.gross_revenue?.date),
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: revenueData['25F'],
    precision: 1,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_as_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.gross_revenue?.date),
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: revenueData['25B'],
    precision: 1,
    ratioUnit: 'YoY',
    ratioValue: revenueData['25B_yoy']?.toString(),
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.gross_revenue?.date),
  }];
};

export const PUBLISHING_PROJECT_REVENUE_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const endDate = apiData?.date || '';
  const yearPrefix = getYearPrefix(apiData?.datatime);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.actual,
    ratioUnit: 'YoY,MoM',
    ratioValue: `${apiData?.actualYoY || 0},${apiData?.actualMoM || 0}`,
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(endDate),
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.forecast,
    ratioUnit: 'YoY',
    ratioValue: `${apiData?.forecastYoY || 0}`,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(endDate),
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.kpi,
    ratioUnit: 'YoY',
    ratioValue: `${apiData?.kpiYoY || 0}`,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(endDate),
  }];
};

export const PUBLISHING_PROJECT_MKT_COST_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const endDate = apiData?.date || '';
  const yearPrefix = getYearPrefix(apiData?.datatime);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.actual,
    ratioUnit: '',
    ratioValue: '',
    definition: 'dbs_mkt_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_gms',
    colorType: 'skyBlue',
    period: buildPeriod(endDate),
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.forecast,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(endDate),
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.kpi,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(endDate),
  }];
};

export const PUBLISHING_PROJECT_HEADCOUNT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const endDate = apiData?.date || '';

  return [{
    title: 'dbs_actual',
    key: 'actual',
    value: apiData?.actual,
    unit: '',
    ratioUnit: 'MoM',
    ratioValue: '',
    definition: 'dbs_publishing_project_headcount_actual_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_pmi',
    colorType: 'skyBlue',
    period: endDate,
  }, {
    title: 'dbs_ytm_actual_avg',
    key: 'ytmActualAvg',
    value: apiData?.ytm_actual_avg,
    unit: '',
    definition: 'dbs_publishing_project_headcount_ytm_actual_avg_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_pmi',
    colorType: 'purple',
    period: buildPeriod(endDate),
  }, {
    title: 'dbs_full_year_kpi_avg',
    key: 'fullYearKPIAvg',
    value: apiData?.full_year_kpi_avg,
    unit: '',
    definition: 'dbs_publishing_project_headcount_full_year_kpi_avg_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(endDate),
  }];
};

export const PUBLISHING_PROJECT_TECH_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const endTime = apiData?.date || '';
  const yearPrefix = getYearPrefix(apiData?.datatime);
  const endDate = endTime ? moment(endTime).format('YYYY-MM') : '';

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.actual,
    ratioUnit: 'MoM',
    ratioValue: `${apiData?.actualMoM || 0}`,
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(endDate),
  },
  // 接口 /api/v1/mgmt_pc/publishing/publishing_project/tech_cost 不再返回 forecast 和 kpi 参数，移除 25F 和 25B 指标
  // {
  //   title: 'dbs_full_year_forecast',
  //   key: '25F',
  //   value: apiData?.forecast,
  //   definition: 'dbs_full_year_forecast_definition',
  //   updateTime: 'dbs_update_time_need',
  //   source: 'dbs_update_source_finance',
  //   colorType: 'purple'
  // }, {
  //   title: 'dbs_full_year_kpi',
  //   key: '25B',
  //   value: apiData?.kpi,
  //   definition: 'dbs_full_year_kpi_definition_l2',
  //   updateTime: 'dbs_update_time_year',
  //   source: 'dbs_update_source_finance',
  //   colorType: 'orange'
  // }
  ];
};

export const PUBLISHING_HEADCOUNT_HEADCOUNT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const actual = apiData?.actual;
  // 接口 /api/v1/mgmt_pc/publishing/hc/headcount 不再返回 actual_mom 和 ytm_actual_avg_mom 参数
  // const actualMoM = apiData?.actual_mom ?? 0;
  const ytmActualAvg = apiData?.ytm_actual_avg;
  // const ytmActualAvgMoM = apiData?.ytm_actual_avg_mom ?? 0;
  const fullYearKPIAvg = apiData?.full_year_kpi_avg;

  return [{
    title: 'dbs_actual',
    key: 'Actual',
    value: actual,
    // ratioUnit: 'MoM',
    // ratioValue: actualMoM.toString(),
    unit: '',
    definition: 'dbs_publishing_headcount_actual_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_pmi',
    colorType: 'skyBlue',
    period: apiData?.date,
  }, {
    title: 'dbs_ytm_actual_avg',
    key: 'ytmActualAvg',
    value: ytmActualAvg,
    unit: '',
    // ratioUnit: 'MoM',
    // ratioValue: ytmActualAvgMoM.toString(),
    definition: 'dbs_publishing_headcount_ytm_actual_avg_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_pmi',
    colorType: 'purple',
    period: buildPeriod(apiData?.date),
  }, {
    title: 'dbs_full_year_kpi_avg',
    key: 'fullYearKPIAvg',
    value: fullYearKPIAvg,
    unit: '',
    definition: 'dbs_publishing_headcount_full_year_kpi_avg_definition',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.date),
  }];
};

export const REVENUE_TREND_TABLE_VS = [
  { title: 'vs1', value: 0, rate: 0, type: 'pillar', displayTitleFormat: 'formattedValue', colorType: 'red', titlePosition: 'outside' },
  { title: 'vs2', value: 0, rate: 0, type: 'pillar', displayTitleFormat: 'formattedValue', colorType: 'red', isHide: true, titlePosition: 'outside' },
  { title: 'vs3', value: 0, rate: 0, type: 'total', displayTitleFormat: 'formattedValue', colorType: 'red', isHide: true },
  { title: '', value: 0, rate: 0, type: 'zero', markWidth: 1,  markHeight: 20, displayTitleFormat: 'none', colorType: 'gray' }
];

export const TABLE_VS_FIELD = ['25F', '25B'];
export const COEFFICIENT = 1.1;

export const PUBLISHING_OVERVIEW_TOTAL_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_revenue_publishing',
  subTitle: buildUpdateTime(apiData?.revenue?.datatime),
  cards: PUBLISHING_OVERVIEW_TOTAL_REVEUNE_METRICS(apiData),
  capsule: PUBLISHING_OVERVIEW_TOTAL_REVENUE(apiData)
});

export const PUBLISHING_OVERVIEW_TOTAL_PROFIT_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_profit_publishing',
  subTitle: buildUpdateTime(apiData?.profit?.datatime),
  cards: PUBLISHING_OVERVIEW_TOTAL_PROFIT_METRICS(apiData),
  capsule: PUBLISHING_OVERVIEW_TOTAL_PROFIT(apiData)
});

export const PUBLISHING_MKTCOST_TOTAL_MKTCOST_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_mkt_total_revenue_publishing_studio',
  subTitle: buildUpdateTime(apiData?.mkt_cost?.datatime),
  cards: PUBLISHING_MKTCOST_TOTAL_MKTCOST_METRICS(apiData),
  capsule: PUBLISHING_MKTCOST_TOTAL_MKTCOST(apiData)
});

export const PUBLISHING_MKTCOST_TOTAL_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_revenue_publishing',
  subTitle: buildUpdateTime(apiData?.gross_revenue?.datatime),
  cards: PUBLISHING_MKTCOST_TOTAL_REVENUE_METRICS(apiData),
  capsule: PUBLISHING_MKTCOST_TOTAL_REVENUE(apiData)
});

export const PUBLISHING_PROJECT_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => {
  const endTime = apiData?.end_time ? moment(apiData.end_time).format('YYYY-MM') : '';

  return {
    title: 'dbs_revenues',
    titleVariable: '',
    subTitle: buildUpdateTime(apiData?.datatime),
    cards: PUBLISHING_PROJECT_REVENUE_METRICS(apiData),
    capsule: PUBLISHING_PROJECT_REVENUE(apiData)
  };
};

export const PUBLISHING_PROJECT_MKT_COST_CARD = (apiData?: any): IBusinessMetricCardConfig => {
  const endTime = apiData?.endTime ? moment(apiData.endTime).format('YYYY-MM') : '';

  return {
    title: 'dbs_subtitle_mktcost',
    titleVariable: '',
    subTitle: buildUpdateTime(apiData?.datatime),
    cards: PUBLISHING_PROJECT_MKT_COST_METRICS(apiData),
    capsule: PUBLISHING_PROJECT_MKT_COST(apiData)
  };
};

export const PUBLISHING_PROJECT_HEADCOUNT_CARD = (apiData?: any): IBusinessMetricCardConfig => {
  return {
    title: 'dbs_headcount',
    titleUnit: '',
    titleVariable: '',
    subTitle: buildUpdateTime(apiData?.datatime),
    cards: PUBLISHING_PROJECT_HEADCOUNT_METRICS(apiData),
    capsule: PUBLISHING_PROJECT_HEADCOUNT(apiData)
  };
};

export const PUBLISHING_PROJECT_TECH_CARD = (apiData?: any): IBusinessMetricCardConfig => {
  const endTime = apiData?.end_time ? moment(apiData.end_time).format('YYYY-MM') : '';

  return {
    title: 'dbs_tech_and_other_cost',
    titleVariable: '',
    subTitle: buildUpdateTime(apiData?.datatime),
    cards: PUBLISHING_PROJECT_TECH_METRICS(apiData),
    capsule: PUBLISHING_PROJECT_TECH(apiData)
  };
};

export const PUBLISHING_HEADCOUNT_HEADCOUNT_CARD = (apiData?: any): IBusinessMetricCardConfig => {
  return {
    title: 'dbs_publishing_headcount',
    titleUnit: '',
    titleVariable: '',
    subTitle: buildUpdateTime(apiData?.date),
    cards: PUBLISHING_HEADCOUNT_HEADCOUNT_METRICS(apiData),
    capsule: PUBLISHING_HEADCOUNT_HEADCOUNT(apiData)
  };
};


export const defaultMontlyTimeline = [
  {
    title: 'Jan',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Feb',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Mar',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Apr',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'May',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Jun',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Jul',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Aug',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Sep',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Oct',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Nov',
    icon: TimeLineIcon,
    data: [],
  },
  {
    title: 'Dec',
    icon: TimeLineIcon,
    data: [],
  },
];
